module.exports = "../static/media/B25Watch.96de5e77.svg";